export default {"src":"/_next/static/media/easycampuslogo-cv.d0b97f3f.svg","height":23,"width":580,"blurWidth":0,"blurHeight":0};